export const meta = {
  id: 'M00',
  slug: 'area-do-mentor',
  title: 'Bem-vindo à área do Mentor',
  description: 'Entenda como o Mentor acompanha seus mentorados e utiliza o Personagrama para dar contexto e continuidade à Mentoria.',
  profile: 'mentor',
  category: 'comece-aqui',
  type: 'getting-started',
  status: 'published',
  order: 210,
  keywords: ['mentor', 'mentorados', 'acompanhamento', 'mentoria', 'começar', 'área do mentor'],
  next: 'M01',
  related: ['A00', 'M02', 'M13'],
  updatedAt: '2026-08-17',
  appVersion: 'v1'
}

# Bem-vindo à área do Mentor

O Mentor utiliza o Personagrama para acompanhar os mentorados sob sua responsabilidade com mais contexto, continuidade e clareza sobre o desenvolvimento de cada pessoa.

Como Mentor, você também pode consultar a experiência do **Aluno / Mentorado**. Isso ajuda a compreender o que ele vê, registra e executa na plataforma.

## Como funciona seu acompanhamento

<Steps>
  <Step title="Acesse seus Mentorados">
    Entre na sua carteira e escolha a pessoa que deseja acompanhar.
  </Step>
  <Step title="Entenda o contexto">
    Consulte a Visão 360, o desenvolvimento, o Plano, a Jornada, as Formações e as Evidências disponíveis.
  </Step>
  <Step title="Conduza a Mentoria">
    Use esse contexto para preparar a conversa, registrar o resumo compartilhado e estabelecer Acordos.
  </Step>
  <Step title="Acompanhe a execução">
    Observe o progresso, as Evidências e os Acordos até a próxima sessão.
  </Step>
</Steps>

<Callout type="important">
  O papel de Mentor não dá acesso a todos os alunos da organização. Você acompanha somente os mentorados vinculados a você dentro das regras do Personagrama.
</Callout>

## O ciclo do Mentor

**Mentorado → contexto → análise → Mentoria → Acordos → execução → acompanhamento.**

O Personagrama não substitui a Mentoria. Ele organiza informações para que o acompanhamento seja mais consistente e conectado ao desenvolvimento real do mentorado.

<HelpImage alt="Área do Mentor no Personagrama" pendingId="M00.1" />
